import { useSignals } from '@preact/signals-react/runtime';
import { WixContext } from '@wix/sdk-react-context';
import { ProvideComponentServiceDefinition } from './core-services/provide-component/index.js';
import React, { useContext } from 'react';
export function ServicesManagerProvider({ servicesManager, children, }) {
    const getProvidedComponent = () => {
        const provideComponentService = servicesManager.hasService(ProvideComponentServiceDefinition)
            ? servicesManager.getService(ProvideComponentServiceDefinition)
            : {
                getAllProviders: () => null,
                getAllTopComponents: () => null,
                getAllBottomComponents: () => null,
            };
        return {
            ProvidersComponent: provideComponentService?.getAllProviders(),
            TopComponents: provideComponentService?.getAllTopComponents(),
            BottomComponents: provideComponentService?.getAllBottomComponents(),
        };
    };
    const { ProvidersComponent, TopComponents, BottomComponents } = getProvidedComponent();
    return (React.createElement(WixContext.Provider, { value: { getService: servicesManager.getService } },
        TopComponents && React.createElement(TopComponents, null),
        ProvidersComponent ? (React.createElement(ProvidersComponent, null, children)) : (children),
        BottomComponents && React.createElement(BottomComponents, null)));
}
export function useGetService() {
    const { getService } = useContext(WixContext);
    if (!getService) {
        throw new Error('No ServiceManagerProvider found in the component tree, make sure to wrap your app with ServicesManagerProvider');
    }
    return getService;
}
export function useService(service) {
    const getService = useGetService();
    useSignals();
    return getService(service);
}
export function useServices(services) {
    const getService = useGetService();
    if (!getService) {
        throw new Error('No ServiceManagerProvider found in the component tree, make sure to wrap your app with ServicesManagerProvider');
    }
    return services.map((service) => getService(service));
}
